import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { trpcRetry } from "#/lib/trpc/retryPolicy"
import { HasCarrotPartnerResponse } from "../types/HasCarrotPartnerResponse"
import ResponseError from "../types/ResponseError"
import { trpc } from "#/lib/trpc/client"

const CARROT_PARTNER_QUERY_KEY = "GetHasCarrotPartner"

export function useGetHasCarrotPartner(
  companyCountryCode: string
): UseQueryResult<HasCarrotPartnerResponse, ResponseError> {
  return useQuery<HasCarrotPartnerResponse, ResponseError>(
    [CARROT_PARTNER_QUERY_KEY, companyCountryCode],
    async () => {
      const result = await trpc.providerFinder.search.query({
        carrotPartner: true,
        countryCode: companyCountryCode,
        pageSize: 1
      })
      return { hasCarrotPartner: result.totalCount > 0 }
    },
    {
      refetchOnWindowFocus: false,
      retry: trpcRetry(1)
    }
  )
}
